<template>
  <v-row>
    <v-col cols="12">
        <domain-image height="70" width="100%" position="center center" transparent class="mb-5"></domain-image>
      <v-row justify="center">
        <callout-button v-if="userDetails.Allows.AddCallouts" class="mb-2 mr-2"></callout-button>
        <issue-button v-if="userDetails.Allows.AddIssues" class="mb-2 mr-2"></issue-button>
        <big-round-button v-if="userDetails.Office.PhoneNumber" color="secondary"
                          :href="'tel:'+userDetails.Office.PhoneNumber" icon="mdi-phone"
                          text="ΚΛΗΣΗ"></big-round-button>
        <big-round-button v-else-if="userDetails.Office.Email" color="secondary"
                          :href="'mailto:'+userDetails.Office.Email" icon="mdi-at" text="Email"></big-round-button>
      </v-row>
    </v-col>

    <v-col cols="12">
      <div v-if="ongoingCallouts.length>0 || openIssues.length>0 ">
        <open-callouts max-height="48vh" class="mb-5"
                       v-if="ongoingCallouts.length>0 && userDetails.Allows.ShowCallouts " hide-buttons
                       :loading="calloutLoading"/>
        <open-issues max-height="48vh" v-if="userDetails.Allows.AddIssues && openIssues.length>0" hide-buttons
                     class="mb-5"
                     :loading="openIssuesLoading"/>
      </div>
      <dept-overview hide-details hide-title v-if="userDetails.Allows.ShowDepts" class="mb-5"
                     :loading="deptLoading"></dept-overview>

      <v-card  :loading="maintenancesLoading">
        <v-card-title> Tα
          <wnl-text> Ανυψωτικά </wnl-text> σας
        </v-card-title>
        <project-list max-height="48vh" :pageSize="5"></project-list>
      </v-card>
      <!-- <v-card>
        <v-card-title> Tα Κτήρια σας</v-card-title>
        <building-list max-height="48vh"></building-list>
      </v-card>-->

      <v-card class="mt-6">
        <v-card-title>Εργασίες</v-card-title>
        <recent-events></recent-events>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import homeMixin from "@/views/Dashboards/mixins/homeMixin";
import ProjectList from "@/views/Projects/components/ProjectList";
import CalloutButton from "@/views/Events/components/CalloutButton";
import DomainImage from "@/components/DomainImage";
import IssueButton from "@/views/Issues/components/IssueButton";
import BigRoundButton from "@/components/BigRoundButton";
import OpenCallouts from "@/views/Events/components/OpenCallouts";
import OpenIssues from "@/views/Events/components/OpenIssues";
import DeptOverview from "@/views/Financial/components/DeptOverview";
import WnlText from "@/wl-unit-text/WnlText";
import BuildingList from "@/views/Buildings/components/BuildingList";
import RecentEvents from "@/views/Events/components/RecentEvents";
// ... other imports ...

export default {
  name: "HomeMobile",
  mixins: [homeMixin],
  components: {
    RecentEvents,
    BuildingList,
    ProjectList,
    WnlText,
    DeptOverview,
    OpenIssues,
    OpenCallouts,
    BigRoundButton,
    IssueButton,
    CalloutButton,
    DomainImage
    // Your components here
  }
}
</script>

<style scoped>
/* Your styles here for mobile */
</style>
